module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SafariView__main-container"
  }, [_c('div', {
    staticClass: "SafariView__header"
  }, [_c('div', {
    staticClass: "SafariView__header-main"
  }, [_c('div', {
    staticClass: "SafariView__header-container"
  }, [_c('div', {
    staticClass: "SafariView__header-inner-container"
  }, [_c('img', {
    staticClass: "SafariView__logo",
    attrs: {
      "src": require("../../../../static/images/logo.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__body"
  }, [_c('div', {
    staticClass: "SafariView__body-container"
  }, [_c('div', {
    staticClass: "SafariView__title"
  }, [_vm._v("\n        KingsConference doesn't work on your browser\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__body-text"
  }, [_vm._v("\n        To join the video meeting\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__body-text-info"
  }, [_vm._v("\n        Install the current version of Google Chrome or Mozilla Firefox\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__action-btn SafariView__action-btn--blue"
  }, [_c('a', {
    staticClass: "SafariView__btn-link",
    attrs: {
      "href": "https://www.google.com/chrome"
    }
  }, [_vm._v("Download Chrome")])]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__action-btn SafariView__action-btn--blue"
  }, [_c('a', {
    staticClass: "SafariView__btn-link",
    attrs: {
      "href": "https://www.mozilla.org/en-US/firefox/new"
    }
  }, [_vm._v("Download Firefox")])]), _vm._v(" "), _c('div', {
    staticClass: "SafariView__body-text-footer"
  }, [_c('p', [_vm._v(" To install and use KingsConference on a mobile device, go to")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "SafariView__link",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.newmedia.conference&hl=en"
    }
  }, [_vm._v(" Google Play\n        ")]), _vm._v(" or the\n         "), _c('a', {
    staticClass: "SafariView__link",
    attrs: {
      "href": "https://itunes.apple.com/app/kingsconference/id1215191816?mt=8"
    }
  }, [_vm._v(" iTunes Store\n        ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217a0cea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/safari-view/safari-view.vue
// module id = 423
// module chunks = 1